import React, { Component } from 'react';
import { Grid, Row, Col, Panel, Tabs, Tab } from 'react-bootstrap';
import CategoryListView from './CategoryListView';
import OrganizationList from './OrganizationList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { categoryActions as actions } from '../../actions';
import '../../content/css/ThemePackage.css';
import AddOrganizationButton from './AddOrganizationButton';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';

class ThemePackageView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: "",
            themePackage: null,
            categories: []
        };

        this.loadingListener = new LoadingListener([], true);
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.setState({ id });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.id !== this.state.id && this.state.id) {
            let themePackage = this.getThemePackageById(this.state.id);
            if (themePackage === null && this.props.categories.length === 0) this.props.requestAll();
            else if (themePackage === null) this.props.requestThemePackages();
            else this.setState({ themePackage });
        }

        if (prevProps.themePackages !== this.props.themePackages) {
            let themePackage = this.getThemePackageById(this.state.id);
            this.setState({ themePackage });
        }

        if (prevState.themePackage !== this.state.themePackage) {
            let categories = this.getCategories();
            this.setState({ categories });
        }

        if (prevProps.categories !== this.props.categories) {
            let categories = this.getCategories();
            this.setState({ categories });
        }
    }

    handleEditCategory = (categoryTheme) => {
        if (!categoryTheme.isAvailable)
            this.handleDeleteCategory(categoryTheme);
        else
            this.props.addOrUpdateCategoryTheme(this.state.id, categoryTheme);
    }

    handleDeleteCategory = (categoryTheme) => {
        this.props.removeCategoryTheme(this.state.id, categoryTheme);
    }

    handleAddOrganization = (id) => {
        this.props.addOrganizationToThemePackage(this.state.id, id);
    }

    handleRemoveOrganization = (id) => {
        this.props.removeOrganizationFromThemePackage(this.state.id, id);
    }

    getThemePackageById = (id) => {
        let themePackages = this.props.themePackages.filter(x => x.id === id);
        return themePackages.length > 0 ? themePackages[0] : null;
    }

    getCategories = () => {
        let themes = this.state.themePackage ? this.state.themePackage.categories : [];
        themes = themes.map(x => { return { ...x, isAvailable: true } });
        let notYetAdded = this.props.categories.filter(x => !themes.some(y => x.code === y.code));
        notYetAdded = notYetAdded.map(x => { return { ...x, isAvailable: false } });
        return themes.concat(notYetAdded);
    }

    getThemePackageName = () => {
        return this.state.themePackage !== null ? this.state.themePackage.name : "";
    }

    getOrganizations = () => {
        return this.state.themePackage ? this.state.themePackage.organizationIds : [];
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div className="theme-package-view">
                <div className="title">
                    <h2>{this.getThemePackageName()}</h2>
                    <span>Manage concepts in this theme, including adding custom feedback and changing their importance.</span>
                </div>
                <Grid fluid>
                    <Panel>
                        <Row>
                            <Col sm={12}>
                                <Tabs id="theme-tabs">
                                    <Tab eventKey={1} title="Concepts">
                                        <div className="title">
                                            <span>Modify individual concepts to better suit your needs.</span>
                                            <span>Availability determines whether the concept is visible to and can be activated by the user.</span>
                                        </div>
                                        <CategoryListView
                                            packageId={this.state.id}
                                            categories={this.state.categories}
                                            categoryGroups={this.props.parents}
                                            isLoading={this.props.isLoading}
                                            onEditCategory={this.handleEditCategory}
                                        />
                                    </Tab>
                                    <Tab eventKey={2} title="Organizations">
                                        <div className="title">
                                            <span>Add and remove organizations from this theme.</span>
                                        </div>
                                        <AddOrganizationButton onClick={this.handleAddOrganization} />
                                        <OrganizationList
                                            organizations={this.getOrganizations()}
                                            isLoading={this.props.isLoading}
                                            onRemove={this.handleRemoveOrganization}
                                        />
                                    </Tab>
                                </Tabs>

                                {isLoading && <LoadingIcon />}
                            </Col>
                        </Row>
                    </Panel>
                </Grid>
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(ThemePackageView);


// WEBPACK FOOTER //
// ./src/components/CategoryView/ThemePackageView.js